import React from 'react';

import { CheckCircleIcon, BanIcon } from '../../styled/Icon';
import clsx from 'clsx';
import { StockStatus } from '../../../@types/stock.enum';
import { IconContainer } from './wrappers';

interface IStatusIcon {
  className?: string;
  status?: StockStatus;
  quantity?: number;
}

const StatusIcon = ({ className, status, quantity = 0 }: IStatusIcon) => {
  if (status === StockStatus.InStock && quantity > 0) {
    return (
      <IconContainer className={className}>
        <CheckCircleIcon />
      </IconContainer>
    );
  }
  if (
    status === StockStatus.InCentralStoreStock ||
    status === StockStatus.Incoming ||
    status === StockStatus.IncomingToCentralStorage ||
    status === StockStatus.Orderable ||
    status === StockStatus.OrderableDirectlyFromSupplier
  ) {
    return (
      <IconContainer className={clsx(className, 'alt')}>
        <CheckCircleIcon />
      </IconContainer>
    );
  }
  if (status === StockStatus.Unavailable) {
    return (
      <IconContainer className={clsx(className, 'unavailable')}>
        <BanIcon />
      </IconContainer>
    );
  }

  return (
    <IconContainer className={clsx(className, 'unknown')}>
      <BanIcon />
    </IconContainer>
  );
};

export default StatusIcon;
